var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert"},[(_vm.isActive)?_c('div',[_c('b-alert',{attrs:{"variant":_vm.type,"show":""}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }